import {ChangeDetectorRef, Component, EventEmitter, HostBinding, Input, Output} from "@angular/core";
import {faInfoCircle, faSyncAlt} from "@fortawesome/pro-solid-svg-icons";
import {ReportService} from "@webmate-web-core/shared/services/report.service";
import {FormsCommonsModule} from "@webmate-web-core/shared/components/forms-commons/forms-commons.module";

import {FormsModule} from "@angular/forms";
import {ReportId, ReportSectionContent} from "../../../../report/report_types";



@Component({
    selector: 'wm-report-section-content',
    templateUrl: './report-section-content.component.html',
    styleUrls: ['./report-section-content.component.less'],
    imports: [
    FormsCommonsModule,
    FormsModule
],
    standalone: true
})
export class ReportSectionContentComponent {
    constructor(private reportService: ReportService, private cdr: ChangeDetectorRef) {
    }

    @Input()
    content: ReportSectionContent;

    @Input()
    reportId?: ReportId;

    @Input()
    doRender = true;

    @Output() onContentUpdate = new EventEmitter<ReportSectionContent>();

    refresh() {
        this.cdr.markForCheck();
    }

    ngOnInit() {
    }

    ngOnChanges(changes: any) {
        this.cdr.markForCheck();
    }

    updateContent() {
        this.onContentUpdate.emit(this.content);
    }

    getBlobUrl(blobId: string): string {
        if (!this.reportId) {
            return '';
        }
        return this.reportService.getBlobUrl(this.reportId, blobId);
    }

    protected readonly faSyncAlt = faSyncAlt;
    protected readonly faInfoCircle = faInfoCircle;
}
